import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/questions/discovery/components/categories.tsx");
